import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { responseLogWithNotification, getPaginationOpts, useUpdatePeriod } from '../../../utils/utils';
import { getPaymentData } from '../../PaymentLog/reducer';
import { getSessionData } from '../../SessionLog/reducer';
import '../../EventLog/components/event-log-page.scss';
import { sessionLogColumns } from '../../SessionLog/constants';
import { paymentLogColumns } from '../../PaymentLog/constants';
import { getColumnsForTable } from '../../../utils/getColumnsForTable';
import { loadPaymentList } from '../../PaymentLog/actions';
import { loadSessionList } from '../../SessionLog/actions';
import PaymentLogGrid from '../../PaymentLog/components/PaymentLogGrid';
import defaultCarImg from '../../../theme/img/default-car.png';
import { Icons } from '../../../components/base/BootstrapComponents';
import SessionLogGrid from '../../SessionLog/components/SessionLogGrid';
import ClientLpnEditPopUp from './ClientLpnEditPopUp';
import { getSystemData } from '../../System/reducer';
import { getClientData } from '../reducer';
import ImagePreviewModal from '../../../components/base/ImagePreviewModal';
import VideoPreviewModal from '../../../components/base/VideoPreviewModal';
import resolveSessionMediaUrl from '../../../utils/resolveSessionMediaUrl';

export default function ClientStatus(props) {
  const dispatch = useDispatch();
  const basicKeys = ['status', 'id', 'parking_zone', 'client', 'lpn', 'description', 'type', 'expiry_at', 'issue_at'];
  const [tab, setTab] = useState(1);
  const [isPopUp, setIsPopUp] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [previewTitle, setPreviewTitle] = useState('');
  const { columns, loadList } = props;
  const navigate = useNavigate();
  const { updatePeriod } = useSelector(getSystemData);
  const { paymentList, paymentListMeta } = useSelector(getPaymentData);
  const { sessionList, sessionListMeta } = useSelector(getSessionData);

  const { currentClient = {} } = useSelector(getClientData);

  const entryImage = resolveSessionMediaUrl(currentClient?.entry_image || currentClient?.entry_image_path || null);
  const exitImage = resolveSessionMediaUrl(currentClient?.exit_image || currentClient?.exit_image_path || null);
  const entryVideo = resolveSessionMediaUrl(currentClient?.entry_video || currentClient?.entry_video_path || null);
  const exitVideo = resolveSessionMediaUrl(currentClient?.exit_video || currentClient?.exit_video_path || null);

  const openPreview = (imageUrl, title) => {
    if (!imageUrl) {
      return;
    }
    setPreviewImage(imageUrl);
    setPreviewTitle(title);
  };

  const openVideoPreview = (videoUrl, title) => {
    if (!videoUrl) {
      return;
    }
    setPreviewVideo(videoUrl);
    setPreviewTitle(title);
  };

  const closePreview = () => {
    setPreviewImage(null);
    setPreviewVideo(null);
    setPreviewTitle('');
  };

  const handleLoadingPaymentList = opts => {
    const paginationOpts = getPaginationOpts(paymentListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { client_id: currentClient.id },
    };
    return dispatch(loadPaymentList(requestData)).catch(responseLogWithNotification);
  };

  const handleLoadingSessionList = opts => {
    const paginationOpts = getPaginationOpts(sessionListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { client_id: currentClient.id },
    };
    return dispatch(loadSessionList(requestData)).catch(responseLogWithNotification);
  };

  const loadData = () => {
    const p1 = handleLoadingPaymentList();
    const p2 = handleLoadingSessionList();
    return Promise.all([p1, p2]);
  };

  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);
  return (
    <div className="client-status">
      <div className="client-basic-information">
        <span className="client-basic-information-title">Основная информация</span>
        <div className="client-basic-photo-list">
          <div className="client-basic-photo-item">
            <div className="client-basic-photo-title">Фото въезда</div>
            <div
              className={classNames('client-basic-photo-image', { clickable: Boolean(entryImage) })}
              style={{ backgroundImage: `url(${entryImage || defaultCarImg})` }}
              onClick={() => openPreview(entryImage, 'Фото въезда')}
            />
          </div>
          <div className="client-basic-photo-item">
            <div className="client-basic-photo-title">Фото выезда</div>
            <div
              className={classNames('client-basic-photo-image', { clickable: Boolean(exitImage) })}
              style={{ backgroundImage: `url(${exitImage || defaultCarImg})` }}
              onClick={() => openPreview(exitImage, 'Фото выезда')}
            />
          </div>
        </div>
        <div className="client-basic-information-box">
          {getColumnsForTable(columns, basicKeys).map((column, index) => (
            <div className="client-basic-information-box-item" key={index}>
              <div className="client-basic-information-box-item-title">{column.text}</div>
              <div className="client-basic-information-box-item-content">
                {column.formatter ? column.formatter(currentClient[column.dataField]) : currentClient[column.dataField] || null}
                {column.dataField === 'lpn' ? (
                  <>
                    {currentClient?.lpn}
                    <div className="client-basic-control-button" onClick={() => setIsPopUp(true)}>
                      <Icons width={24} height={24} customIcon icon="pencile" className="button-icons" />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          ))}
          {entryVideo ? (
            <div className="client-basic-information-box-item">
              <div className="client-basic-information-box-item-title">Видео въезда</div>
              <div className="client-basic-information-box-item-content">
                <button type="button" className="client-basic-information-video-link" onClick={() => openVideoPreview(entryVideo, 'Видео въезда')}>
                  Смотреть
                </button>
              </div>
            </div>
          ) : null}
          {exitVideo ? (
            <div className="client-basic-information-box-item">
              <div className="client-basic-information-box-item-title">Видео выезда</div>
              <div className="client-basic-information-box-item-content">
                <button type="button" className="client-basic-information-video-link" onClick={() => openVideoPreview(exitVideo, 'Видео выезда')}>
                  Смотреть
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="client-status-table-box">
        <div className="client-status-tab-menu">
          <div className={classNames('client-status-tab-item', { selected: tab === 1 })} onClick={() => setTab(1)}>Журнал сессий</div>
          <div className={classNames('client-status-tab-item', { selected: tab === 2 })} onClick={() => setTab(2)}>Журнал платежей</div>
        </div>
        <div className="client-status-tables-container">
          <div className="client-status-tables-container-title">
            <div className="client-status-title">{tab === 1 ? 'Журнал сессий' : 'Журнал платежей'}</div>
            <div className="client-status-show-table" onClick={() => navigate(tab === 1 ? `/session-log?client_id=${encodeURIComponent(currentClient.id)}` : `/payment-log?client_id=${encodeURIComponent(currentClient.id)}`)}>{tab === 1 ? 'Все сессии клиента' : 'Все платежи клиента'}</div>
          </div>
          { tab === 1 ? <SessionLogGrid meta={sessionListMeta} data={sessionList} columns={getColumnsForTable(sessionLogColumns, ['num', 'ended_at', 'started_at', 'status', 'updated_at', 'lpn'])} /> : null }
          { tab === 2 ? <PaymentLogGrid meta={paymentListMeta} data={paymentList} columns={getColumnsForTable(paymentLogColumns, ['host', 'paid_at', 'amount', 'rrn', 'masked_pan', 'method', 'type', 'setting'])} /> : null }
          { isPopUp ? <ClientLpnEditPopUp loadList={loadList} onHide={() => setIsPopUp(false)} item={currentClient} /> : null }
        </div>
      </div>
      <ImagePreviewModal open={Boolean(previewImage)} imageUrl={previewImage} title={previewTitle} onClose={closePreview} />
      <VideoPreviewModal open={Boolean(previewVideo)} videoUrl={previewVideo} title={previewTitle} onClose={closePreview} />
    </div>
  );
}
